var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBook48Line = function SvgIconBook48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 8.3H15.6a5.31 5.31 0 0 0-5.3 5.3v20.8c0 2.92 2.38 5.3 5.3 5.3h19.2c1.6 0 2.9-1.3 2.9-2.9V11.2c0-1.6-1.3-2.9-2.9-2.9Zm-19.2 3.4h18.7v17.4H15.6c-.67 0-1.31.14-1.9.37V13.6c0-1.05.85-1.9 1.9-1.9Zm18.7 24.6H15.6a1.9 1.9 0 1 1 0-3.8h18.7v3.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 15.3H19v3.4h10v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconBook48Line;